module.exports = __webpack_public_path__ + "img/logo_antara.513f3e87.png";